<div class="view-container">
  <mat-card class="prescription-list-container">
    <div class="prescription-list__header">
      <div class="mbp-page-header">
        <div class="mbp-page-header__icon">
          <mat-icon>library_books</mat-icon>
        </div>
        <h1 class="mbp-page-header__title">Prescriptions</h1>
      </div>

      <form class="prescription-list__filters" [formGroup]="orderFilterForm">
        <mat-form-field appearance="outline" class="prescription-list__search">
          <input
            type="text"
            formControlName="search"
            matInput
            placeholder="Search prescriptions"
          />
          <mat-icon matPrefix>search</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline" class="prescription-list__status">
          <mat-label>Status</mat-label>
          <mat-select formControlName="status">
            @for (status of orderStatuses; track status) {
              <mat-option [value]="status">
                {{ status.status }}
              </mat-option>
            }
          </mat-select>
          @if (selectedStatus) {
            <button
              (click)="resetStatus($event)"
              mat-icon-button
              matSuffix
              type="button"
              [attr.aria-label]="'Clear status filter'"
            >
              <mat-icon>close</mat-icon>
            </button>
          }
        </mat-form-field>
      </form>
    </div>

    <mat-paginator
      class="prescription-list__paginator"
      [length]="totalNumberOfOrders"
      [pageIndex]="page - 1"
      [pageSize]="limit"
      [pageSizeOptions]="[10, 15, 20]"
      showFirstLastButtons
      (page)="onPageChange($event)"
      aria-label="Select page of prescriptions"
    >
    </mat-paginator>

    <div class="mbp-table-wrap">
      <table
        mat-table
        [dataSource]="ordersDataSource"
        matSort
        (matSortChange)="sortOrders($event)"
        class="prescription-list mbp-data-table"
      >
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef class="id-col">#</th>
          <td mat-cell *matCellDef="let order" class="id-col">{{ order.id }}</td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef class="name-col">Name</th>
          <td mat-cell *matCellDef="let order" class="name-col">
            {{ getEntityName(order) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let order">
            <span class="badge {{ getBadgeBackground(order.status) }}">
              {{ order.status.status }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="sage">
          <th mat-header-cell *matHeaderCellDef>Sage</th>
          <td mat-cell *matCellDef="let order">
            <span [class]="getSageSyncClass(order)">
              {{ getSageSyncLabel(order) }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="contact">
          <th mat-header-cell *matHeaderCellDef>Contact</th>
          <td mat-cell *matCellDef="let order">{{ getOwnerPhoneNumber(order) }}</td>
        </ng-container>

        <ng-container matColumnDef="meds_assigned">
          <th mat-header-cell *matHeaderCellDef class="flag-col">Medicine</th>
          <td mat-cell *matCellDef="let order" class="flag-col">
            <mat-checkbox
              class="prescription-list__flag"
              [disableRipple]="true"
              (click)="$event.preventDefault()"
              color="primary"
              [checked]="isMedicineAssigned(order)"
              aria-label="Medicine assigned"
            >
            </mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="entities_assigned">
          <th mat-header-cell *matHeaderCellDef class="flag-col">Entity</th>
          <td mat-cell *matCellDef="let order" class="flag-col">
            <mat-checkbox
              class="prescription-list__flag"
              [disableRipple]="true"
              (click)="$event.preventDefault()"
              color="primary"
              [checked]="isEntityAssigned(order)"
              aria-label="Entity assigned"
            >
            </mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="created_at">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            sortActionDescription="Sort by date created"
          >
            Created
          </th>
          <td mat-cell *matCellDef="let order">{{ getCreationTime(order) }}</td>
        </ng-container>

        <ng-container matColumnDef="updated_at">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            sortActionDescription="Sort by date updated"
          >
            Updated
          </th>
          <td mat-cell *matCellDef="let order">{{ formatTime(order.updated_at) }}</td>
        </ng-container>

        <ng-container matColumnDef="view_prescription_file">
          <th mat-header-cell *matHeaderCellDef class="file-col">Prescription file</th>
          <td
            mat-cell
            *matCellDef="let order"
            class="file-col"
            (click)="$event.stopPropagation()"
          >
            <div class="prescription-list__file-actions">
              @if (isPrescriptionFileChecking(order)) {
                <button
                  mat-stroked-button
                  class="prescription-list__action"
                  disabled
                  aria-label="Checking prescription file"
                >
                  <mat-icon>hourglass_empty</mat-icon>
                </button>
              } @else if (prescriptionFileExists(order)) {
                <button
                  (click)="openPrescriptionFile($event, order)"
                  mat-stroked-button
                  class="prescription-list__action"
                >
                  <mat-icon>open_in_new</mat-icon>
                  Open
                </button>
              } @else {
                <button
                  (click)="openPrescriptionUploadDialog($event, order)"
                  mat-stroked-button
                  color="primary"
                  class="prescription-list__action"
                >
                  <mat-icon>cloud_upload</mat-icon>
                  Upload
                </button>
              }
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          (click)="openPrescription(row.id)"
          *matRowDef="let row; columns: displayedColumns"
        ></tr>
      </table>
    </div>
  </mat-card>
</div>
